import { motion } from "framer-motion";

const principles = [
  {
    num: "01",
    title: "Rigorous Due Diligence",
    description: "Every opportunity is stress-tested before we present it.",
  },
  {
    num: "02",
    title: "Aligned Interests",
    description: "We invest alongside our clients where appropriate.",
  },
  {
    num: "03",
    title: "Discretion",
    description:
      "We operate with complete confidentiality and professionalism.",
  },
  {
    num: "04",
    title: "Execution Focus",
    description:
      "Strategy without delivery is just opinion. We see it through.",
  },
];

export const Approach = () => {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="py-24 md:py-36"
      style={{
        background: "var(--bg-dark)",
        color: "var(--text-inverse)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section label */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-sm tracking-[0.2em] uppercase mb-4"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 500,
            color: "var(--gold-dark)",
          }}
        >
          Our Philosophy
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="text-3xl md:text-4xl lg:text-5xl tracking-tight mb-16 md:mb-20"
          style={{
            fontFamily: "var(--font-serif)",
            fontWeight: 400,
            color: "var(--text-inverse)",
          }}
        >
          Our Approach
        </motion.h2>

        {/* Principles grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {principles.map((item, index) => (
            <motion.div
              key={item.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: index * 0.12,
                ease: [0.25, 0.46, 0.45, 0.94],
              }}
              className="approach-item"
              data-testid={`approach-item-${index}`}
            >
              <span className="approach-number">{item.num}</span>
              <div>
                <h3
                  className="text-xl md:text-2xl tracking-tight mb-3"
                  style={{
                    fontFamily: "var(--font-serif)",
                    fontWeight: 600,
                    color: "var(--text-inverse)",
                  }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{
                    fontFamily: "var(--font-sans)",
                    fontWeight: 300,
                    color: "rgba(250, 248, 245, 0.65)",
                    lineHeight: 1.8,
                  }}
                >
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
